import { getMeta } from '../../service'
const get_meta = {
  data() {
    return {
      meta: ''
    }
  },
  methods: {
    async getMeta(arr, cb) {
      let res = await getMeta({name: arr}, (error) => this.$Message.error('请求错误！'))
      if(res.status == 'success') {
        this.$set(this.$data, 'meta', res.meta)
        if(cb) cb()
      } else {
        this.$Message.error(res.message)
      }
    }
  }
}
export { get_meta }
